import React from "react";
import PropTypes from "prop-types";
import MyInvestmentPage from "./investments/my_investment_page";
import InvestmentList from "./investments/investment_list";

function InvestmentComponent(props) {
  const { is_mypage } = props;

  return is_mypage === true ?
    <MyInvestmentPage {...props} /> : <InvestmentList {...props} />;
}

InvestmentComponent.propTypes = {
  is_mypage: PropTypes.bool.isRequired
};

export default InvestmentComponent;
